"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.productionStatisticTypes = exports.productionStatisticReducer = exports.productionStatisticAction = void 0;
const production_statistic_component_1 = __importDefault(require("./sub-components/production-statistic.component"));
const production_statistic_action_1 = __importDefault(require("./production-statistic.action"));
exports.productionStatisticAction = production_statistic_action_1.default;
const production_statistic_reducer_1 = __importDefault(require("./production-statistic.reducer"));
exports.productionStatisticReducer = production_statistic_reducer_1.default;
const production_statistic_types_1 = require("./production-statistic.types");
Object.defineProperty(exports, "productionStatisticTypes", { enumerable: true, get: function () { return production_statistic_types_1.productionStatisticTypes; } });
exports.default = production_statistic_component_1.default;
